
// 成本费用明细
import TableList from "@components/templates/tablelist";
import { HttpSettlementDetailList } from "@/service/fedex";
import { HttpGetManageBillList } from "@/service/newbigaccount";
import { mapGetters } from "vuex";
// import mixin from "../mixin";
import comExcel from '@components/templates/excelalert'
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search:{
                    EQ_billingType: 4
                }
            },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpGetManageBillList,
        interceptRequest(params) {
            if(params.search.IN_status == 6){
                params.search.IN_status = [2,6]
            }
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexUpdateBillimport",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/freightSettlement/item/export', this.formData, {
                        executor:'request',
                        download:true,
                        method:'get',
                    }).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    })
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList','getCarrierServiceList','getAlllogProCodeList', 'getCarrierServiceAllList', 'getCustomServiceAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "export",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                },
                {
                    label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    tag: 'vInput',
                    key: 'EQ_invoiceNo',
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    default: this.handleDateRange().join(' ~ '),
                    show: true,
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('fbb.bill.source_system',{defaultValue:'来源系统'}),
                    tag: 'vSelect',
                    key: 'EQ_sourceSystem',
                    more: true,
                    options: [
                        {value:'fbb',label:this.$t('fbb.bill.cloud_warehouse',{defaultValue:'云仓'})},
                        {value:'bizarkCloudShipping',label:'Bizark Cloud Shipping'},
                        {value:'UN_KNOW',label:this.$t('fbb.bill.unknown',{defaultValue:'未知'})},
                    ],
                    props: {
                        filterable: true,
                        clearable: true,
                    }
                },
                {
                    label: this.$t('global.common.organization',{defaultValue:'组织'}),
                    tag: 'vSelect',
                    key: 'EQ_organization_id',
                    more: true,
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                        clearable: true,
                    }
                },
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    more: true,
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                        clearable: true,
                    }
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getBillcusWareList.map(item=>{
                        return {
                            value: item.attach.code,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.service_code',{defaultValue:'承运商服务'}),
                    // label: '承运商服务',
                    tag: 'vSelect',
                    // key: 'EQ_carrierServiceCode',
                    key: 'EQ_carrierServiceName',
                    more: true,
                    options: this.getCarrierServiceAllList.map(item=>{
                        return {
                            // value: item.attach.carrierServiceCode,
                            value: item.label,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.logistics_products',{defaultValue:'物流产品'}),
                    // label: '物流产品',
                    tag: 'vSelect',
                    key: 'EQ_groupName',
                    more: true,
                    // options: [
                    //     {value:'FedEx',label:'FedEx'},
                    //     {value:'UPS',label:'UPS'},
                    // ],
                    options: this.getCustomServiceAllList.map(item=>{
                        return {
                            value:item.label,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.ismarkup',{defaultValue:'是否加价'}),
                    tag: 'vSelect',
                    key: 'EQ_markup',
                    more: true,
                    options: [
                        {value:1,label: this.$t('erp.global.yes',{defaultValue:'是'})},
                        {value:0,label: this.$t('erp.global.no',{defaultValue:'否'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.status',{defaultValue:'状态'}),
                    tag: 'vSelect',
                    key: 'IN_status',
                    more: true,
                    // options: [
                    //     {value:'PROCESSED', label:this.$t('fbb.costmanage.processed',{defaultValue:'待处理'})},
                    //     // {value:'DEDUCTIONED', label:this.$t('fbb.costmanage.deductioned',{defaultValue:'已扣款'})},
                    //     // {value:'CANCELED', label:this.$t('fbb.costmanage.canceled',{defaultValue:'已作废'})},
                    //     {value:'BILL_CREATED', label:this.$t('fbb.costmanage.bill_created',{defaultValue:'账单已创建'})},
                    //     // {value:'BILL_CONFIRMED', label:this.$t('fbb.costmanage.bill_confirmed',{defaultValue:'账单已确认'})},
                    //     {value:'ERROR', label:this.$t('fbb.headlogistics.exception',{defaultValue:'异常'})},
                    // ],
                    options: [
                        { label: this.$t('fbb.bill.pending_processing',{defaultValue:'待处理'}), value: 0},
                        { label: this.$t('fbb.headlogistics.exception',{defaultValue:'异常'}), value: 1},
                        { label: this.$t('fbb.bill.associated_bills',{defaultValue:'已关联账单'}), value: 6},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.adjustment.sourceno_bill',{defaultValue:'关联账单'}),
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    more: true,
                },
                {
                    label: this.$t('fbb.headlogistics.associated_number',{defaultValue:'来源单号'}),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    more: true,
                },
                {
                    label: this.$t('fbb.bill.settlement_date',{defaultValue:'结算日期'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_settlementAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
            ]
        },
        columns() {
            return [
            {
                title: 'Tracking NO',
                key: 'trackingNo',
            },
            {
                // title: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流产品服务'})+'/'+this.$t('fbb.alloment.carrier_code',{defaultValue:'物流产品'}),
                title: this.$t('fbb.bill.service_code',{defaultValue:'承运商服务'})+'/'+this.$t('fbb.bill.logistics_products',{defaultValue:'物流产品'}),
                key:'carrierServiceName',
                render:(h,{row})=>{
                    return <div>
                        <div>{row.carrierServiceName}</div>
                        <div>{row.groupName}</div>
                    </div>
                }
            },
            // {
            //     title: this.$t('fbb.billmanage.total_cost',{defaultValue:'总费用'}),
            //     key: 'totalCost',
            // },
            {
                title: this.$t('fbb.adjustment.list_costname',{defaultValue:'收费项'}),
                key: 'costName',
            },
            {
                title: this.$t('fbb.bill.estimated_amount',{defaultValue:'预估金额'})+'/'+this.$t('erp.product.currency',{defaultValue:'币种'}),
                render:(h,{row})=>{
                    return <div>{row.estimatedCost} {row.currency}</div>
                }
            },
            {
                title: this.$t('fbb.bill.actual_amount',{defaultValue:'实际金额'}),
                render:(h,{row})=>{
                    return <div>{row.actualCost} {row.currency}</div>
                }
            },
            {
                title: this.$t('fbb.bill.amount_receivable',{defaultValue:'应收金额'}),
                render:(h,{row})=>{
                    return <div>{row.cost} {row.currency}</div>
                }
            },
            {
                title: this.$t('fbb.bill.difference_amount',{defaultValue:'差异金额'}),
                render:(h,{row})=>{
                    return <div>{row.diffCost} {row.currency}</div>
                }
            },
            {
                title: this.$t('fbb.adjustment.sourceno_bill',{defaultValue:'关联账单'}),
                key: 'billNo',
            },
            // {
            //     title: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
            //     render: (h,{row})=>{
            //         return <div>{row.periodCode} ({row.startTime} ~ {row.endTime})</div>
            //     }
            // },
            {
                title: this.$t('global.common.status',{defaultValue:'状态'}),
                render: (h, { row }) => {
                    // switch (row.status) {
                    //     case "PROCESSED": return <div>{this.$t('fbb.costmanage.processed',{defaultValue:'待处理'})}</div>; break;
                    //     case "DEDUCTIONED": return <div>{this.$t('fbb.costmanage.deductioned',{defaultValue:'已扣款'})}</div>; break;
                    //     case "CANCELED": return <div>{this.$t('fbb.costmanage.canceled',{defaultValue:'已作废'})}</div>; break;
                    //     case "BILL_CREATED": return <div>{this.$t('fbb.costmanage.bill_created',{defaultValue:'账单已创建'})}</div>; break;
                    //     case "BILL_CONFIRMED": return <div>{this.$t('fbb.costmanage.bill_confirmed',{defaultValue:'账单已确认'})}</div>; break;
                    //     case 'ERROR': return this.$t('fbb.headlogistics.exception',{defaultValue:'异常'}); break;
                    // }
                    switch( row.status) {
                        case 0: return <div>{this.$t('fbb.costmanage.processed',{defaultValue:'待处理'})}</div>; break
                        case 2: return <div>{this.$t("fbb.bill.been_associated",{defaultValue:"账单已关联"})}</div>; break;
                        case 1: return <div>{this.$t('fbb.headlogistics.exception',{defaultValue:'异常'})}</div>; break;
                        case 6: return <div>{this.$t("fbb.bill.been_associated",{defaultValue:"账单已关联"})}</div>; break;
                    }
                }
            },
            {
                 title: this.$t('fbb.headlogistics.associated_number',{defaultValue:'来源单号'})+'/'+this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                render:(h,{row})=>{
                    return <div>
                        {row.sourceNo}
                        <div>{row.invoiceNo}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.organization',{defaultValue:'组织'})+'/'+this.$t('global.common.warehouse',{defaultValue:'仓库'})+'/'+this.$t('global.common.project',{defaultValue:'项目'}),
                key: 'orgName',
                render:(h,{row})=>{
                    let orgWarehouseCode = row.orgWarehouseCode
                    let orgWarehouse = this.getBillcusWareList.find(item=>{
                        return item.attach.code == orgWarehouseCode
                    })
                    return <div>
                        <div>{row.organizationName || '--'}</div>
                        <div>{orgWarehouse ? orgWarehouse.label : '--'}</div>
                        <div>{row.lineName || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t("fbb.bill.invoice_settlement_date",{defaultValue:"结算日期/发票日期"}),
                key: 'settlementAt',
                render:(h,{row})=>{
                    return <div>
                        <div>{row.settlementAt||'--'}</div>
                        <div>{row.invoiceDate||'--'}</div>
                    </div>
                }
            },
            ];
        },

    },

};
